import moment from 'moment'
import { SpeLevel } from './constants'

export const ageInMonths = (code: string): number =>
  moment().diff(
    moment()
      .subtract(code.substr(3, 5), 'days') // +1 would result in adding 1 at the end of the string, minus changes the value of the number in the string, so double negative.
      .format('YYYY-MM-DD'),
    'months'
  )

export const getSpeLevelFromExaminationCode = (code: string): SpeLevel =>
  parseInt(code.substr(8), 10) as SpeLevel
